<template>
    <base-button v-if="!byMonth"
                 tag="a"
                 class="button--no-uppercase"
                 :href="url"
                 v-bind="$attrs"
                 target="_blank"
                 secondary
                 download
    >
        {{ text }}
    </base-button>
    <button-dropdown v-else
                     button-type="secondary"
    >
        <template slot="buttonInside">
            <span class="dropdown__title">
                {{ text }}
            </span>
        </template>

        <div v-for="group in options"
             :key="group.title"
             class="dropdown__item-group"
        >
            <p class="dropdown__item dropdown__item--title">
                {{ group.title }}
            </p>
            <a
                v-for="item in group.items"
                :key="item.value"
                :href="exportUrl(item.value)"
                target="_blank"
                download
                v-bind="$attrs"
                class="nav-main__link"
            >
                <span class="dropdown__item">
                    {{ item.title }}
                </span>
            </a>
        </div>
    </button-dropdown>
</template>

<script>
import { $t, $d } from '@/translations';
import { BaseButton, ButtonDropdown } from '@/components/buttons/index';

function prepareMonthOptions() {
    const groups = [];
    const date = new Date();
    let year = null;
    let group = null;
    for (let i = 0; i <= 12; i += 1) {
        const startDate = date;
        const startMonth = startDate.getMonth();

        const calculatedDate = new Date();
        calculatedDate.setDate(1);
        calculatedDate.setMonth(startMonth - i);

        if (year !== calculatedDate.getFullYear()) {
            year = calculatedDate.getFullYear();
            group = { title: year, items: [] };
            groups.push(group);
        }
        group.items.push({ title: $d(calculatedDate, 'justMonth'), value: calculatedDate.toJSON().substr(0, 10) });
    }
    return groups;
}

export default {
    name: 'ExportButton',
    components: {
        BaseButton,
        ButtonDropdown,
    },
    props: {
        url: {
            type: String,
            required: true,
        },
        text: {
            type: String,
            default: $t('dashboard.exportCsv'),
        },
        byMonth: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        exportUrl() {
            return month => `${this.url}${this.url.indexOf('?') === -1 ? '?' : '&'}month=${month}`;
        },
        options() {
            return this.byMonth ? prepareMonthOptions() : [];
        },
    },
};
</script>

<style scoped lang="scss">
.dropdown {
    &__item-group {
        &:not(:first-child) {
            margin-top: 15px;
        }
    }
}
</style>
